import * as React from 'react';
import { I18n } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import Popup, { FooterData } from '../../Popup';
import { PopupBody } from './styles';
import { signOut } from '../../../containers/MultiAppAuthentication/actions';

interface NotificationPopupProps {
	isDisplayed: boolean;
	children: React.ReactNode;
	dispatch: Dispatch<StoreState>;
}

const NotificationPopup = ({ isDisplayed, children, dispatch }: NotificationPopupProps) => {
	const popupFooter: FooterData = {
		label: I18n.t('messages.back_to_login'),
		onAccept: () => dispatch(signOut()),
	};

	return (
		<Popup
			isDisplayed={isDisplayed}
			label={I18n.t('messages.notification')}
			footer={popupFooter}
		>
			<PopupBody>
				{children}
			</PopupBody>
		</Popup >
	);
};

export default NotificationPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/NotificationPopup/index.tsx